import { $$, on } from "../../utils/dom";

export const onContentLoaded = (): void => {
  const toggleButtons = $$(".js-table__toggle");
  const toggleDetails = $$(".js-table__details");

  function toggle(e: MouseEvent) {
    const target = e.target as HTMLTableRowElement;
    const { index } = target.dataset;

    target?.classList.toggle("-open");

    toggleDetails &&
      toggleDetails[Number(index) || 0].classList.toggle("-open");
  }

  toggleButtons?.forEach((button) => on(button, "click", toggle));
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
